import {PackagingLabelItem} from './PackagingLabelItem';
import {FileManager} from '../../shared/Models/FileManager';

export class PackagingLabel {
  public id: number;
  public packingListNumber?: string;
  public deliveryDealer: any;
  public packagingLabelItems: PackagingLabelItem[];
  public replyItem?: any;
  public labelFile?: FileManager;
  constructor() {
  }
}
